import styled, { css } from 'styled-components';

import { Text, CardContainer, mediaQuery } from '@catalyze/ui';

export const SectionContainer = styled.section`
    padding: 1rem 0;
    display: flex;
    justify-content: space-between;
`;

export const SectionTitle = styled(Text)`
    font-size: ${({ theme }) => theme.fontSizes[7]};
    margin-bottom: 0.25rem;
`;

export const SectionDescription = styled(Text)`
    font-size: ${({ theme }) => theme.fontSizes[5]};
    color: ${({ theme }) => theme.colors.fontTertiary};
`;

export const SectionCard = styled(CardContainer)`
    display: flex;
    flex-flow: column;
    width: 100%;
    max-width: 30rem;
    min-width: 30rem;
    padding: 1.5rem;
    ${mediaQuery(
        2,
        css`
            max-width: 33rem;
            min-width: 33rem;
            padding: 1.5rem;
        `
    )}
`;
